import styled from "@emotion/styled"
import { IoMdHand } from "react-icons/io"
import { HiHeart, HiVolumeOff, HiVolumeUp } from "react-icons/hi"
import type { RoomBranding } from "../../../recoil/atoms/room/types"
import { IoArrowRedo } from "react-icons/io5"

export interface StylesProps {
  issmall?: string
  value?: boolean
  roomStyles?: RoomBranding
  isLandscape?: boolean
  changeSizeIconDependingHeightVideo?: (
    minHeightIcon: number,
    maxHeightIcon: number
  ) => number
}

export const StyledHandIcon = styled(IoMdHand)<StylesProps>`
  stroke-width: 36px;
  stroke: ${({ roomStyles }) => roomStyles?.overlayEmojiStrokeColor ?? "white"};
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  &:hover {
    color: ${({ value, issmall }) =>
      issmall === "false" && value && "#fee831 !important"};
  }
`

export const StyledHeartIcon = styled(HiHeart)<StylesProps>`
  color: rgba(0, 0, 0, 0.2);
  stroke-width: 1.5;
  stroke: ${({ roomStyles }) => roomStyles?.overlayEmojiStrokeColor ?? "white"};
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  &:hover {
    color: ${({ issmall, value }) => issmall === "false" && value && "#ff3333"};
  }
  &:active {
    color: #ff0000;
  }
`

export const StyledShareIcon = styled(IoArrowRedo)<StylesProps>`
  color: rgba(0, 0, 0, 0.2);
  stroke-width: 36px;
  stroke: ${({ roomStyles }) => roomStyles?.overlayEmojiStrokeColor ?? "white"};
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  &:active {
    color: white;
  }
`

export const HiVolumeOffIcon = styled(HiVolumeOff)<StylesProps>`
  margin-top: 10px;
  stroke: ${({ roomStyles }) => roomStyles?.overlayEmojiStrokeColor ?? "white"};
  stroke-width: 1px;
  font-size: 2rem;
  color: rgba(0, 0, 0, 0.2);
  -webkit-tap-highlight-color: transparent;
  &:hover {
    color: ${({ issmall }) => issmall === "false" && "#fee831 !important"};
  }
`

export const HiVolumeOffDisabledIcon = styled(HiVolumeOff)<StylesProps>`
  margin-top: 10px;
  stroke: ${({ roomStyles }) => roomStyles?.overlayEmojiStrokeColor ?? "white"};
  stroke-width: 1px;
  color: rgba(0, 0, 0, 0.2);
  -webkit-tap-highlight-color: transparent;
  &:hover {
    color: ${({ issmall }) => issmall === "false" && "#fee831 !important"};
  }
`

export const HiVolumeUpIcon = styled(HiVolumeUp)<StylesProps>`
  margin-top: 10px;
  stroke: ${({ roomStyles }) => roomStyles?.overlayEmojiStrokeColor ?? "white"};
  stroke-width: 1px;
  color: rgba(0, 0, 0, 0.2);
  -webkit-tap-highlight-color: transparent;
  &:hover {
    color: ${({ issmall }) => issmall === "false" && "#fee831 !important"};
  }
`

export const StyledMuteIcon = styled.i<StylesProps>`
  stroke: ${({ roomStyles }) => roomStyles?.overlayEmojiStrokeColor ?? "white"};
  stroke-width: 1px;
  color: rgba(0, 0, 0, 0.2);
  -webkit-tap-highlight-color: transparent;
  font-size: ${({ isLandscape, changeSizeIconDependingHeightVideo }) =>
    isLandscape
      ? "2rem"
      : changeSizeIconDependingHeightVideo !== undefined
      ? `${changeSizeIconDependingHeightVideo(30, 36)}px`
      : "2rem"};
  cursor: pointer;
`
